import React, { useRef } from 'react'
import { Input } from 'antd'

export function ProductName({
  lang,
  label,
  field = 'nombre',
  setNames,
  names,
  required,
  maxLength,
}) {
  const ref = useRef()
  return (
    <Input
      ref={ref}
      maxLength={maxLength}
      required={required}
      prefix={
        label && (
          <span style={{ fontSize: 12, color: 'grey', width: 80 }}>
            {label}
          </span>
        )
      }
      defaultValue={names?.[lang]?.[field]}
      onInput={() =>
        setNames((o) => ({
          ...o,
          [lang]: {
            ...o[lang],
            [field]: ref.current.input.value,
          },
        }))
      }
    />
  )
}
